/* Dezine Kids v2.18 — product conversion + optional uniform block spacing */
(function(){
  'use strict';
  if(window.__dkConversionV218Installed) return;
  window.__dkConversionV218Installed=true;

  var PIN_STORAGE_KEY='dk_delivery_pincode';
  var CITY_PREFIXES={
    '110':'Delhi','121':'Faridabad','122':'Gurgaon','160':'Chandigarh','226':'Lucknow','302':'Jaipur','380':'Ahmedabad','395':'Surat','400':'Mumbai','411':'Pune','440':'Nagpur','452':'Indore','500':'Hyderabad','560':'Bengaluru','600':'Chennai','641':'Coimbatore','682':'Kochi','700':'Kolkata'
  };
  var MAJOR_CITY_PREFIXES=['400','560','600','500','700','411','380','302','226','160','395','452','440','641','682'];

  function isProductPage(){
    return !!(document.body && document.body.classList.contains('template-product'));
  }

  function prepareAccountLink(){
    var link=document.querySelector('.icons-col a.site-settings');
    if(!link) return;
    link.setAttribute('aria-label','Login or My Account');
    link.setAttribute('title','Login / My Account');
  }

  function styleTrustBlock(){
    if(!isProductPage()) return;
    document.querySelectorAll('.product-single__meta .storeFeatures').forEach(function(block){
      block.style.removeProperty('display');
      block.classList.add('dk-trust-card');
    });
  }

  function analytics(pin,zone){
    try{
      window.dataLayer=window.dataLayer||[];
      window.dataLayer.push({event:'dk_pincode_checked',pincode:pin,delivery_zone:zone,delivery_source:'local_rules'});
    }catch(e){}
  }

  function makeWhatsappLink(pin){
    var title=document.querySelector('.product-single__title');
    var productTitle=title ? title.textContent.trim() : 'this product';
    var text='Hi Dezine Kids, I need urgent delivery help for '+productTitle+(pin ? ' to pincode '+pin : '')+'.';
    return 'https://wa.me/918505993079?text='+encodeURIComponent(text);
  }

  function getDeliveryZone(pin){
    if(/^110\d{3}$/.test(pin)) return 'delhi';
    if(/^(121|122|201)\d{3}$/.test(pin)) return 'ncr';
    if(MAJOR_CITY_PREFIXES.indexOf(pin.slice(0,3))!==-1) return 'major_city';
    return 'india_standard';
  }

  function getCity(pin){
    return CITY_PREFIXES[pin.slice(0,3)] || '';
  }

  function getDeliveryText(zone){
    if(zone==='delhi' || zone==='ncr') return 'Delivery normally takes <strong>1–2 working days</strong> after dispatch.';
    if(zone==='major_city') return 'Delivery normally takes <strong>1–3 working days</strong> after dispatch.';
    return 'Delivery normally takes <strong>2–5 working days</strong> after dispatch.';
  }

  function savePincode(pin){
    try{ localStorage.setItem(PIN_STORAGE_KEY,pin); }catch(e){}
  }

  function loadPincode(){
    try{
      var pin=localStorage.getItem(PIN_STORAGE_KEY)||'';
      return /^[1-9][0-9]{5}$/.test(pin) ? pin : '';
    }catch(e){ return ''; }
  }

  function supportHtml(pin){
    return '<div class="dk-pincode-support"><span class="dk-support-icon">⚡</span><span>Need it urgently?</span> '+
      '<a target="_blank" rel="nofollow noopener noreferrer" href="'+makeWhatsappLink(pin)+'">WhatsApp us</a>'+
      '<span class="dk-pincode-or"> or </span>'+
      '<a href="tel:+918505993079">Call us</a></div>';
  }

  function checkerMarkup(){
    return '<div class="dk-pincode-title"><span class="dk-title-icon">📍</span><span>Check Delivery Availability</span></div>'+
      '<div class="dk-pincode-row">'+
        '<input class="dk-pincode-input" type="text" inputmode="numeric" autocomplete="postal-code" maxlength="6" pattern="[0-9]{6}" placeholder="Enter 6-digit pincode" aria-label="Enter delivery pincode">'+
        '<button class="dk-pincode-btn" type="button">Check</button>'+
      '</div>'+
      '<div class="dk-pincode-result" aria-live="polite"></div>'+
      '<div class="dk-pincode-after-check" hidden></div>';
  }

  function findMovablePincodeBlock(){
    var meta=document.querySelector('.product-single__meta');
    if(!meta) return null;

    var editorBlocks=meta.querySelectorAll('[data-shopify-editor-block]');
    for(var i=0;i<editorBlocks.length;i++){
      try{
        var data=JSON.parse(editorBlocks[i].getAttribute('data-shopify-editor-block')||'{}');
        if(data.id==='hr_Vac8gV') return editorBlocks[i];
      }catch(e){}
    }

    var hrs=meta.querySelectorAll('hr.mb0');
    for(var j=0;j<hrs.length;j++){
      var border=(hrs[j].getAttribute('style')||'').toLowerCase();
      if(border.indexOf('#222222')!==-1 || border.indexOf('#222')!==-1) return hrs[j];
    }
    return hrs.length ? hrs[0] : null;
  }

  function turnBlockIntoChecker(block){
    if(!block) return null;
    if(block.getAttribute('data-dk-pincode-checker')==='true') return block;

    var wrap=document.createElement('div');
    Array.prototype.slice.call(block.attributes||[]).forEach(function(attr){
      if(attr.name!=='class' && attr.name!=='style') wrap.setAttribute(attr.name,attr.value);
    });
    wrap.className='dk-pincode-checker';
    wrap.setAttribute('data-dk-pincode-checker','true');
    wrap.innerHTML=checkerMarkup();
    block.parentNode.replaceChild(wrap,block);
    return wrap;
  }

  function bindPincodeChecker(wrap){
    if(!wrap || wrap.getAttribute('data-dk-pincode-bound')==='true') return;
    wrap.setAttribute('data-dk-pincode-bound','true');

    var savedPin=loadPincode();
    var input=wrap.querySelector('.dk-pincode-input');
    var button=wrap.querySelector('.dk-pincode-btn');
    var result=wrap.querySelector('.dk-pincode-result');
    var afterCheck=wrap.querySelector('.dk-pincode-after-check');
    if(!input || !button || !result || !afterCheck) return;
    input.value=savedPin;

    function refreshSupport(pin){
      afterCheck.innerHTML=supportHtml(pin);
    }

    function hideDeliveryDetails(){
      afterCheck.hidden=true;
    }

    function showResult(){
      var pin=(input.value||'').replace(/\D/g,'').slice(0,6);
      input.value=pin;
      hideDeliveryDetails();
      result.className='dk-pincode-result is-visible';

      if(!/^[1-9][0-9]{5}$/.test(pin)){
        result.classList.add('is-error');
        result.innerHTML='<div class="dk-delivery-error">Please enter a valid 6-digit Indian pincode.</div>';
        return;
      }

      savePincode(pin);
      refreshSupport(pin);

      var zone=getDeliveryZone(pin);
      var city=getCity(pin);
      var destination=pin+(city ? ', '+city : '');

      result.innerHTML=
        '<div class="dk-delivery-available"><span class="dk-result-icon">✓</span> Shipping available to <strong>'+destination+'</strong></div>'+
        '<div class="dk-delivery-line"><span class="dk-result-icon">📦</span><span>Dispatch normally <strong>within 24 hours</strong>.</span></div>'+
        '<div class="dk-delivery-line"><span class="dk-result-icon">🚚</span><span>'+getDeliveryText(zone)+'</span></div>';
      afterCheck.hidden=false;
      analytics(pin,zone);
    }

    input.addEventListener('input',function(){
      this.value=this.value.replace(/\D/g,'').slice(0,6);
      result.className='dk-pincode-result';
      result.innerHTML='';
      hideDeliveryDetails();
    });
    input.addEventListener('keydown',function(e){ if(e.key==='Enter'){ e.preventDefault(); showResult(); } });
    button.addEventListener('click',showResult);
  }

  function initPincodeChecker(){
    if(!isProductPage()) return;
    var wrap=document.querySelector('[data-dk-pincode-checker="true"]');
    if(!wrap) wrap=turnBlockIntoChecker(findMovablePincodeBlock());
    bindPincodeChecker(wrap);
  }

  function findEqualSpacingController(meta){
    var editorBlocks=meta.querySelectorAll('[data-shopify-editor-block]');
    for(var i=0;i<editorBlocks.length;i++){
      try{
        var data=JSON.parse(editorBlocks[i].getAttribute('data-shopify-editor-block')||'{}');
        if(data.id==='hr_eA3Vby') return editorBlocks[i];
      }catch(e){}
    }

    /* The pincode HR has already been converted above. If the optional HR below Pickup is enabled,
       it is now the remaining #222 divider and acts only as the spacing controller. */
    var hrs=meta.querySelectorAll('hr');
    for(var j=0;j<hrs.length;j++){
      var raw=(hrs[j].getAttribute('style')||'').toLowerCase();
      if(raw.indexOf('#222222')!==-1 || raw.indexOf('#222')!==-1) return hrs[j];
    }
    return null;
  }

  function readBottomMarginValue(el,meta){
    var node=el;
    while(node && node!==meta){
      var cls=typeof node.className==='string' ? node.className : '';
      var match=cls.match(/(?:^|\s)mb(\d+)(?:\s|$)/);
      if(match) return parseInt(match[1],10);
      node=node.parentElement;
    }
    return 15;
  }

  function markTransparentSpacerHrs(meta,controller){
    Array.prototype.slice.call(meta.children||[]).forEach(function(child){
      if(child===controller || child.tagName!=='HR') return;
      var raw=(child.getAttribute('style')||'').replace(/\s/g,'').toLowerCase();
      if(raw.indexOf('rgba(0,0,0,0)')!==-1 || raw.indexOf('transparent')!==-1){
        child.classList.add('dk-uniform-ignore');
      }
    });
  }

  function applyUniformBlockSpacing(){
    if(!isProductPage()) return;
    var meta=document.querySelector('.product-single__meta');
    if(!meta) return;

    meta.classList.remove('dk-uniform-block-spacing');
    meta.style.removeProperty('--dk-block-gap');
    meta.querySelectorAll('.dk-spacing-controller,.dk-uniform-ignore').forEach(function(el){
      el.classList.remove('dk-spacing-controller','dk-uniform-ignore');
      el.style.removeProperty('display');
    });

    var controller=findEqualSpacingController(meta);
    if(!controller) return;

    var gap=readBottomMarginValue(controller,meta);
    controller.classList.add('dk-spacing-controller');
    markTransparentSpacerHrs(meta,controller);
    meta.style.setProperty('--dk-block-gap',gap+'px');
    meta.classList.add('dk-uniform-block-spacing');
  }

  function init(){
    prepareAccountLink();
    styleTrustBlock();
    initPincodeChecker();
    applyUniformBlockSpacing();
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init);
  else init();
  document.addEventListener('shopify:section:load',init);
})();
